module.exports = __webpack_public_path__ + "img/quanping.315a40c2.png";